export default __webpack_public_path__ + "static/media/react.939b859f.svg";